import {computed, effect, Signal, signal} from '@angular/core';
import {AbstractControl} from "@angular/forms";
import {merge} from "rxjs";

export function createVisibleErrorMessage(
  control: Signal<AbstractControl>,
  errorMessage: Signal<string | Record<string, string> | undefined>,
): Signal<string | undefined> {
  const tick = signal(0);

  effect(() => {
    const c = control();
    const subscription = merge(c.statusChanges, c.valueChanges).subscribe(() =>
      tick.update(value => value + 1)
    );
    return () => subscription.unsubscribe();
  });

  return computed(() => {
    tick();
    const c = control();
    const msg = errorMessage();

    if (!msg || !c.invalid || !c.dirty) return undefined;

    if (typeof msg === 'string') return msg;

    const errors = c.errors;
    if (!errors) return undefined;

    for (const key of Object.keys(errors)) {
      if (msg[key]) return msg[key];
    }
    return undefined;
  });
}
